import * as React from 'react';
import { getMemberListProducts } from '../Goods/service';
import conf from './conf';
import type { IConf } from './conf';
import { formatPrice } from '@/components/EcocreditsMonthlyMadness/utils';

import type { IProductItem } from '@/components/EcocreditsMonthlyMadness/type';

export type prodcutItemType = IConf &
    IProductItem & {
        img: string;
        variantImg: string;
        tag?: string;
        link_buy: string;
    };

const { useState, useEffect } = React;

export const useProductList = (locale: string) => {
    const [loading, setLoading] = useState(true);
    const [productList, setProductList] = useState<prodcutItemType[]>([]);

    const config = conf[locale] || null;

    useEffect(() => {
        const getVids = () => config?.map((item) => item.variantId);

        if (!getVids()) return;

        getMemberListProducts(
            {
                variantIds: getVids(),
            },
            locale,
        )
            .then((res) => {
                if (!res || res.code !== '0') return;

                const sortedList = [];
                const data = res.data?.map((item: any) => {
                    const newItem = { ...item };
                    const confItem = config.find((ele: any) => ele.variantId === item.variantId);

                    newItem.link_buy = `https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`;
                    newItem.price = formatPrice(String(item.price), locale);
                    newItem.compareAtPrice = formatPrice(String(item.compareAtPrice), locale);

                    if (confItem) {
                        newItem.title = confItem.title;
                        newItem.desc = confItem.desc;
                        newItem.pc = confItem.pc;
                        newItem.h5 = confItem.h5;
                    }
                    return newItem;
                });

                for (const item in config) {
                    sortedList.push(data.find((ele: any) => ele.variantId === config[item].variantId));
                }

                setProductList(sortedList);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [locale, config]);

    return { productList, loading };
};
